import { useEffect } from 'react';

/**
 * As duas camadas do papel de parede, mais o parallax do mouse.
 *
 * O movimento é de poucos pixels e propositalmente lento: fundo que acompanha o
 * cursor rápido demais cansa em página de catálogo, onde a pessoa passa minutos.
 *
 * Escreve em variáveis CSS em vez de mexer no style do elemento a cada evento —
 * assim o navegador só recalcula o transform, que ele resolve no compositor, e
 * a rolagem da lista de skins não sente nada.
 */
export function Background() {
  useEffect(() => {
    const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const temMouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (semMovimento || !temMouse) return;

    const AMPLITUDE = 18; // pixels de deslocamento máximo
    let frame = 0;

    function mover(e: MouseEvent) {
      if (frame) return; // um cálculo por quadro, não um por evento
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        const x = (e.clientX / window.innerWidth - 0.5) * -2;
        const y = (e.clientY / window.innerHeight - 0.5) * -2;
        const raiz = document.documentElement;
        raiz.style.setProperty('--bg-x', `${Math.round(x * AMPLITUDE)}px`);
        raiz.style.setProperty('--bg-y', `${Math.round(y * AMPLITUDE)}px`);
      });
    }

    window.addEventListener('mousemove', mover, { passive: true });
    return () => {
      window.removeEventListener('mousemove', mover);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <>
      <div className="bg-art" aria-hidden />
      <div className="bg-veil" aria-hidden />
    </>
  );
}
